'use client';
import Image from 'next/image';
import { useTheme } from '@/app/components/Theme'; // Correct import for useTheme

export const ConnectWithStrava = () => {
  const imgPath =
    '/strava/1.1 connect with strava/btn_strava_connectwith_orange/btn_strava_connectwith_orange.svg';
  return (
    <Image
      src={encodeURI(imgPath)}
      alt='Connect with Strava'
      width={200}
      height={50}
      style={{
        maxWidth: '100%',
        height: 'auto',
      }}
    />
  );
};

export const PoweredByStrava = () => {
  const imgPath =
    '/strava/1.2 strava api logos/powered by Strava/pwrdBy_strava_white/api_logo_pwrdBy_strava_horiz_white.svg';
  return (
    <div className='w-full flex justify-center items-center bg-orange-400'>
      <Image
        src={encodeURI(imgPath)}
        alt='Powered by Strava'
        width={100}
        height={30}
        style={{
          maxWidth: '100%',
          height: 'auto',
        }}
      />
    </div>
  );
};

export const GarminLogo = () => {
  const imgPath = '/garmin/connect-app-icon.png';
  return (
    <div className='w-full flex justify-center items-center bg-transparent'>
      <Image
        src={imgPath}
        alt='Garmin Connect'
        width={24}
        height={24}
        style={{
          maxWidth: '100%',
          height: 'auto',
        }}
      />
    </div>
  );
};

interface GarminConnectBadgeProps {
  onClick?: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const GarminConnectBadge = ({
  onClick,
  disabled,
  children,
}: GarminConnectBadgeProps) => {
  const { isDarkMode } = useTheme();

  const imgPath = isDarkMode
    ? '/garmin/Garmin-Tag-black-low-res.png' // White logo for dark mode
    : '/garmin/Garmin-Tag-white-low-res.png'; // Black logo for light mode

  return (
    <button
      className='rounded-lg overflow-hidden'
      onClick={onClick}
      disabled={disabled}
    >
      <Image
        src={imgPath}
        alt='Connect with Garmin'
        width={100} // Assuming a reasonable width
        height={25} // Assuming a reasonable height, adjust as needed
        style={{
          maxWidth: '100%',
          height: 'auto',
        }}
      />
      {children}
    </button>
  );
};
